export const set = (state, data) => {
  state.records = data;
};

export const create = (state, data) => {
  state.records.push(data);
};

export const setSingleRecord = (state, data) => {
  const recordIndex = state.records.findIndex(record => record.id === data.id);
  if (recordIndex > -1) {
    state.records[recordIndex] = data;
  } else {
    create(state, data);
  }
};

export const update = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      state.records[index] = data;
    }
  });
};

/* when you don't want to overwrite the whole object */
export const updateAttributes = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      state.records[index] = { ...state.records[index], ...data };
    }
  });
};

export const updatePresence = (state, data) => {
  // data can be a map of id -> availability_status (string)
  // or id -> { availability_status, last_seen_at, connected_at }
  state.records.forEach((element, index) => {
    const presenceInfo = data[element.id];

    // CRITICAL FIX: Only update if presenceInfo exists for this user
    // Don't mark as offline if they're simply not in the payload
    // (they might be the current user viewing the page)
    if (!presenceInfo) {
      return; // Skip this record, don't modify it
    }

    // If presenceInfo is a string, it's the availability status
    if (typeof presenceInfo === 'string') {
      state.records[index].availability_status = presenceInfo || 'offline';
      return;
    }

    // If it's an object, merge known presence attributes
    if (typeof presenceInfo === 'object') {
      const { availability_status, last_seen_at, connected_at } = presenceInfo;
      if (availability_status) {
        state.records[index].availability_status = availability_status;
      }
      if (last_seen_at) {
        state.records[index].last_seen_at = last_seen_at;
      }
      if (connected_at) {
        state.records[index].connected_at = connected_at;
      }
    }
  });
};

export const updateSingleRecordPresence = (
  records,
  { id, availabilityStatus }
) => {
  const [selectedRecord] = records.filter(record => record.id === Number(id));
  if (selectedRecord) {
    selectedRecord.availability_status = availabilityStatus;
  }
};

export const destroy = (state, id) => {
  state.records = state.records.filter(record => record.id !== id);
};
